module.exports = __webpack_public_path__ + "static/media/spaceteam.c018a136.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Spaceteam/spaceteam.png
// module id = 181
// module chunks = 0